/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react'
import { MonthType, FocusedInput } from '@datepicker-react/hooks'

interface Context {
  activeMonths?: MonthType[]
  focusedDate: Date
  isDateFocused: (date: any) => boolean
  isDateSelected: (date: Date) => boolean
  isDateHovered: (date: Date) => boolean
  isDateBlocked: (date: Date) => boolean
  isFirstOrLastSelectedDate: (date: Date) => boolean
  onDateFocus: (date: Date) => void
  onDateHover: (date: Date) => void
  onDateSelect: (date: Date) => void
  startDate: Date
  endDate: Date
  focusedInput: FocusedInput
}

export const dateRangeContextDefaultValue: Context = {
  startDate: null,
  endDate: null,
  focusedInput: null,
  focusedDate: null,
  isDateFocused: (date: Date) => false,
  isDateSelected: (date: Date) => false,
  isDateHovered: (date: Date) => false,
  isDateBlocked: (date: Date) => false,
  isFirstOrLastSelectedDate: () => false,
  onDateFocus: (date: Date) => {},
  onDateHover: (date: Date) => {},
  onDateSelect: (date: Date) => {}
}

export default React.createContext<Context>(dateRangeContextDefaultValue)
